module.exports = __webpack_public_path__ + "img/help-icon.c085cb66.svg";